import React, { useEffect, useState } from "react"
import { get, post } from "helpers/api_helper"
import { PROFILE } from "helpers/url_helper"
import Notifications from "components/Notifications"

const Profile = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => { getProfile(); }, [])

    const getProfile = async () => {
        setLoading(true);
        setData(null);
        const res = await get(PROFILE);
        if (res.status === 200) setData(res?.response);
        setLoading(false);
    }

    const updateProfileCall = async () => {
        setSaving(true);
        const res = await post(PROFILE, data);
        if (res.status === 200) Notifications("Company profile updated!", "success");
        else Notifications("Failed to update profile.", "error");
        setSaving(false);
    }

    const set = (key, val) => setData(prev => ({ ...prev, [key]: val }));
    const inp = { width:"100%", padding:"9px 12px", border:"1px solid #e2e8f0", borderRadius:"8px", fontSize:"13px", outline:"none", background:"#fff" };
    const lbl = { fontSize:"12px", fontWeight:"600", color:"#64748b", marginBottom:"5px", display:"block", textTransform:"uppercase", letterSpacing:"0.4px" };
    const box = { background:"#f8fafc", borderRadius:"10px", padding:"20px", marginBottom:"20px", border:"1px solid #e2e8f0" };

    if (loading) return (
        <div style={{ textAlign:"center", padding:"40px" }}>
            <i className="fas fa-spinner fa-spin text-primary" style={{ fontSize:"24px" }}></i>
            <p style={{ marginTop:"10px", color:"#94a3b8", fontSize:"13px" }}>Loading profile...</p>
        </div>
    );

    return (
        <div>
            <div style={box}>
                <div style={{ fontWeight:"700", fontSize:"13px", color:"#334155", marginBottom:"16px", display:"flex", alignItems:"center", gap:"8px" }}>
                    <i className="bx bx-building text-primary"></i> Basic Information
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"16px", marginBottom:"16px" }}>
                    <div>
                        <label style={lbl}>Company Name</label>
                        <input style={inp} type="text" value={data?.title || ""} onChange={e => set("title", e.target.value)} placeholder="e.g. DG Dental Lab" />
                    </div>
                    <div>
                        <label style={lbl}>Company Logo</label>
                        <input style={{ ...inp, padding:"6px 12px" }} type="file" accept="image/*" />
                        <div style={{ fontSize:"11px", color:"#94a3b8", marginTop:"4px" }}>PNG, JPG up to 2MB.</div>
                    </div>
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"16px" }}>
                    <div>
                        <label style={lbl}>Contact Email</label>
                        <input style={inp} type="email" value={data?.email || ""} onChange={e => set("email", e.target.value)} placeholder="admin@company.com" />
                    </div>
                    <div>
                        <label style={lbl}>Mobile Number</label>
                        <input style={inp} type="tel" value={data?.mobile || ""} onChange={e => set("mobile", e.target.value)} placeholder="+91 98765 43210" />
                    </div>
                </div>
            </div>

            <div style={{ ...box, marginBottom:"24px" }}>
                <div style={{ fontWeight:"700", fontSize:"13px", color:"#334155", marginBottom:"16px", display:"flex", alignItems:"center", gap:"8px" }}>
                    <i className="bx bx-map text-primary"></i> Address Details
                </div>
                <div style={{ marginBottom:"16px" }}>
                    <label style={lbl}>Full Address</label>
                    <textarea style={{ ...inp, height:"80px", resize:"vertical" }} value={data?.address || ""} onChange={e => set("address", e.target.value)} placeholder="Street, Area, Landmark..." />
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:"16px" }}>
                    <div>
                        <label style={lbl}>City</label>
                        <input style={inp} type="text" value={data?.city || ""} onChange={e => set("city", e.target.value)} placeholder="City" />
                    </div>
                    <div>
                        <label style={lbl}>Pincode</label>
                        <input style={inp} type="text" value={data?.pincode || ""} onChange={e => set("pincode", e.target.value)} placeholder="400001" maxLength={6} />
                    </div>
                    <div>
                        <label style={lbl}>Website</label>
                        <input style={inp} type="url" value={data?.website || ""} onChange={e => set("website", e.target.value)} placeholder="https://yourlab.com" />
                    </div>
                </div>
            </div>

            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                <button onClick={getProfile} style={{ padding:"9px 18px", background:"#f8fafc", color:"#64748b", border:"1px solid #e2e8f0", borderRadius:"8px", fontWeight:"600", fontSize:"13px", cursor:"pointer", display:"flex", alignItems:"center", gap:"6px" }}>
                    <i className="mdi mdi-refresh" /> Reload
                </button>
                <button onClick={updateProfileCall} disabled={saving} style={{ padding:"10px 24px", background:"#2563eb", color:"#fff", border:"none", borderRadius:"8px", fontWeight:"700", fontSize:"13px", cursor:"pointer", display:"flex", alignItems:"center", gap:"8px" }}>
                    {saving ? <><i className="fas fa-spinner fa-spin" /> Saving...</> : <><i className="bx bx-save" /> Save Profile</>}
                </button>
            </div>
        </div>
    );
}

export default Profile;
